// extracted by mini-css-extract-plugin
module.exports = {"content":"SubmitLanding_content__1pxTG","header":"SubmitLanding_header__3vIDA"};